import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';

import './index.scss';

ReactDOM.render(<Router />, document.getElementById('root'));
